<template>
  <div>
    <back ref="back"></back>
    <div class="box"  v-show="loaded">
      <div class="header" v-if="!user.isvip">
        <div>
          <div class="avatar-wrap">
            <div>
              <div class="avatar"><img v-lazy="user.avatar"></div>
              <div class="nickname">{{user.nickname}}</div>
              <div class="uid">ID:{{user.id}}</div>
            </div>
          </div>
          <div class="detail-wrap">
            <div>
              <div class="row1"><span>{{user.time_length}}</span>小时</div>
              <div class="row2">累计学习时长</div>
            </div>
            <div class="border-left">
              <div class="row1"><span>{{user.complete_course}}</span>节</div>
              <div class="row2">已完成课程数</div>
            </div>
          </div>
          <!-- 引导冲会员 -->
          <!-- <router-link tag="div" class="get-vip" to="/vip"><img src="~common/image/vip-logo.png" alt=""> 升级会员</router-link> -->
        </div>
      </div>
      <!-- vip的个人中心 -->
      <div class="vip-header" v-else>
        <div class="info-wrap">
          <img src="~common/image/user-vip-bg.png" alt="">
          <div class="avatar-wrap">
            <div class="avatar"><img v-lazy="user.avatar"></div>
            <div>
              <div class="nickname">{{user.nickname}}</div>
              <div class="uid">ID:{{user.id}}</div>
            </div>
            <div class="vip-log"><img src="~common/image/vip-logo-white.png" alt=""> VIP会员</div>
            <div class="words">golo维修课堂，手把手带你实战维修！</div>
          </div>
          <div class="end">会员截止日期：{{user.enddate}}</div>
        </div>
        <div class="detail">
          <div>
            <div class="row1"><span>{{user.time_length}}</span>小时</div>
            <div class="row2">累计学习时长</div>
          </div>
          <div>
            <div class="row1"><span>{{user.complete_course}}</span>节</div>
            <div class="row2">已完成课程数</div>
          </div>
        </div>
      </div>
      <div class="blank"></div>
      <div class="group border-bottom" style="padding:6px 0;">
        <router-link tag="div" to="/personal/wallet" class="item">
          <div class="icon-wrap">
            <img src="@/common/image/wallet.png" alt="">
          </div>
          <div class="name">
            我的钱包
          </div>
          <div class="right">
            <i class="iconfont icon-mjiantou"></i>
          </div>
        </router-link>
      </div>
      <!-- <div class="group border-bottom" style="padding:6px 0;">
        <div @click="toJifen" class="item">
          <div class="icon-wrap">
            <img src="@/common/image/integral.png" class="integral" alt="">
          </div>
          <div class="name">
            我的积分
          </div>
          <div class="right">
            <i class="iconfont icon-mjiantou"></i>
          </div>
        </div>
      </div> -->
      <div class="group border-bottom" style="padding:6px 0;">
        <router-link tag="div" to="/personal/coupon" class="item">
          <div class="icon-wrap">
            <img src="@/common/image/coupon.png" alt="">
          </div>
          <div class="name">
            优惠券
          </div>
          <div class="right">
            <i class="iconfont icon-mjiantou"></i>
          </div>
        </router-link>
      </div>
      <!-- <div class="group border-bottom">
        <router-link tag="div" to="/personal/bought" class="item">
          <div class="icon-wrap">
            <img src="@/common/image/bought.png" alt="">
          </div>
          <div class="name">
            已购课程
          </div>
          <div class="right">
            <i class="iconfont icon-mjiantou"></i>
          </div>
        </router-link>
        <router-link tag="div" to="/personal/certification" class="item">
          <div class="icon-wrap">
            <img src="@/common/image/certification.png" alt="">
          </div>
          <div class="name">
            我的证书
          </div>
          <div class="right">
            <i class="iconfont icon-mjiantou"></i>
          </div>
        </router-link>
      </div> -->
      <div class="group border-bottom" style="padding:6px 0;">
        <router-link class="item" to="/personal/follow">
          <div class="icon-wrap">
            <img src="@/common/image/follow.png" alt="">
          </div>
          <div class="name">
            关注的大咖
          </div>
          <div class="right">
            <i class="iconfont icon-mjiantou"></i>
          </div>
        </router-link>
      </div>
      <div class="group border-bottom" style="padding:6px 0;">
        <div @click="toBind" class="item">
          <div class="icon-wrap">
            <img src="@/common/image/account.png" alt="">
          </div>
          <div class="name">
            绑定golo账户
          </div>
          <div class="right">
            <i class="iconfont icon-mjiantou"></i>
          </div>
        </div>
      </div>
      <div class="group border-bottom" style="padding:6px 0;">
        <div class="item" to="" @click="toBindPhone">
          <div class="icon-wrap">
            <img src="@/common/image/phone.png" alt="" class="phone">
          </div>
          <div class="name">
            绑定手机号
          </div>
          <div class="right">
            <i class="iconfont icon-mjiantou"></i>
          </div>
        </div>
      </div>
      <!--
      <div class="group border-bottom">
        <router-link tag="div" to="/personal/xxxx" class="item">
          <div class="icon-wrap">
            <img src="@/common/image/question.png" alt="">
          </div>
          <div class="name">
            帮助中心
          </div>
          <div class="right">
            <i class="iconfont icon-mjiantou"></i>
          </div>
        </router-link>
      </div>
      -->
      <div style="padding:16px;" @click="clear"></div>
    </div>
    <tab></tab>
    <!-- 加载动画 -->
    <loading v-show="!loaded"></loading>
    <popup ref="popup">
      <div class="tips">
        <div class="text">开通积分需要手机验证</div>
        <div class="btn" @click="toBindPhone">马上验证</div>
      </div>
    </popup>
  </div>
</template>
<script type="text/ecmascript-6">
import Tab from '@/components/tab/tab'
import Loading from 'components/base/loading/loading.vue'
import Popup from 'components/base/ui/popup'
import back from '@/components/base/ui/back.vue'
import {getUserInfo, isOpenIntegral, isBind} from '@/api/user-center'
import {RES_OK} from '@/api/config'
export default {
  components: {
    Tab,
    Loading,
    Popup,
    back
  },
  data() {
    return {
      loaded: false,
      user: {},
      open: false, // 开通积分
      bind: false
    }
  },
  created() {
    getUserInfo().then((res) => {
      let data = res.data
      if (data && data.code === RES_OK && data.data) {
        this.user = data.data
        this.loaded = true
      }
    })
    isOpenIntegral().then(({data}) => {
      if (data.code === RES_OK) {
        this.open = true
      }
    })
    isBind().then(({data}) => {
      if (data.code === RES_OK) {
        this.bind = true
      }
    })
  },
  methods: {
    toBind() {
      if (this.user.is_golo_user) {
        this.$toast('您已绑定')
      } else {
        this.$router.push('/personal/bind/bind')
      }
    },
    clear() {
      // 情况localstorage内容, 方便移动端测试
      localStorage.setItem('gzhPopupTimestamp', '')
      localStorage.setItem('vip-banner', '')
      // clear()
    },
    toJifen() {
      if (this.open) {
        this.$router.push({
          path: '/personal/integral'
        })
      } else {
        this.$refs.popup.show()
      }
    },
    toBindPhone() {
      this.$refs.popup.close()
      if (this.bind) {
        this.$router.push({
          path: '/personal/bindsuccess'
        })
      } else {
        this.$router.push({
          path: '/personal/bindphone'
        })
      }
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .box
    padding-bottom size(140)
  .border-left
    position relative
    &:after
      content ' '
      display block
      width 1px
      height 100%
      top 0
      left 0
      transform scaleX(.5)
      background #424242
      position absolute
  .group
    padding size(24) 0
    background #fff
  .item
    display table
    width 100%
    height size(80)
    box-sizing border-box
    padding-left size(53)
    padding-right size(82)
    >div
      display table-cell
      vertical-align middle
    .icon-wrap
      text-align left
      width size(66)
      img
        display block
        width size(36)
        &.integral
          width size(42)
          position relative
          left -2px
        &.phone
          width size(38)
          position relative
          left -1px
    .name
      color #666666
      font-size size(30)
      font-weight 800
    .right
      width size(30)
      text-align right
      .iconfont
        color #666666
        font-size size(32)
  .header
    width: 100%
    position relative
    padding-bottom: 66.6666%
    >div
      position absolute
      top: 0
      left: 0
      width: 100%
      height: 100%
      background-image: url('~common/image/user-bg.png')
      -webkit-background-size: 100% 100%
      background-size: 100% 100%
      background-repeat: no-repeat
      .avatar-wrap
        height: 71.2%
        display flex
        justify-content center
        flex-direction row
        flex-wrap nowrap
        align-items center
        width: 100%
        text-align center
        >div
          width: 100%
          .avatar
            position relative
            width: 21.3%
            padding-bottom: 21.3%
            margin: 0 auto
            img
              position absolute
              top: 0
              left: 0
              width: 100%
              height: 100%
              -webkit-border-radius: 50%
              -moz-border-radius: 50%
              border-radius: 50%
              border 1px solid #ddd
          .nickname
            color: #fff
            font-size: size(40)
            margin-top: size(20)
          .uid
            font-size size(24)
            color #bfbfbf
            text-align center
            margin-top size(16)
      .detail-wrap
        height: 28.8%
        width: 100%
        display flex
        justify-content space-between
        flex-direction row
        flex-wrap nowrap
        align-items center
        text-align center
        color: #fff
        margin-top: size(-10)
        position relative
        &:after
          content ' '
          display block
          height 1px
          width 100%
          right 0
          left 0
          top: 0
          transform scaleY(.5)
          background #424242
          position absolute
        >div
          width: 50%
          font-size size(20)
          .row1
            span
              font-size: size(36)
          .row2
            font-size: size(20)
            margin-top: size(20)
    .get-vip
      z-index 2
      position absolute
      right 0
      top size(60)
      background #fff
      line-height size(52)
      border-top-left-radius size(26)
      border-bottom-left-radius size(26)
      min-width size(132)
      font-size size(24)
      color darken($color-vip, 40%)
      background-color lighten($color-vip, 60%)
      background linear-gradient(to right, lighten($color-vip, 60%), lighten($color-vip, 50%))
      text-align center
      padding 0 size(20)
      img
        display inline-block
        height size(26)
        vertical-align middle
        position relative
        top -1px
  .blank
    height size(20)
    background #f9f7f8
  .vip-header
    padding-top size(26)
    background #fff
    overflow hidden
    .info-wrap
      position relative
      color #fff
      img
        display block
        width 100%
      .avatar-wrap
        position absolute
        left percentage(64/750)
        right percentage(64/750)
        top percentage(50/364)
        >div
          float left
          &:nth-child(2)
            margin-left size(20)
            width 50%
      .avatar
        width size(82)
        height size(82)
        border-radius 50%
        overflow hidden
        background #ddd
        border 1px solid #fff
      .nickname
        font-size size(30)
        margin-top size(10)
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
      .uid
        font-size size(22)
        margin-top size(8)
      .vip-log
        font-size size(26)
        font-weight 800
        float right!important
        margin-top size(14)
        img
          height size(24)
          width auto
          display inline
      .words
        width 100%
        text-align center
        font-size size(34)
        font-weight 800
        margin-top size(40)
      .end
        font-size size(20)
        position absolute
        bottom percentage(64/364)
        right percentage(64/750)
    .detail
      display flex
      padding size(16) size(50) size(30)
      align-items center
      text-align center
      >div
        flex 1
        font-size size(20)
        .row1
          span
            font-size: size(36)
        .row2
          color #999
          font-size: size(20)
          margin-top: size(20)
  .tips
    text-align center
    .text
      margin size(80) 0 size(60)
      font-size size(32)
      color #3a3a3a
      font-weight 800
    .btn
      width size(216)
      line-height size(72)
      color #ffffff
      background $color-theme
      border-radius 8px
      font-size size(28)
      margin 0 auto
  //大屏设备
  @media only screen and (min-width: 1280px) {
    .header {
      padding-bottom: 25%;
      .avatar-wrap > div .avatar {
        width: 10% !important
        padding-bottom: 10% !important
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/personal/personal.vue